import { useLanguage } from "@/hooks/useLanguage";
import { SUPPORTED_LANGUAGES } from "@/i18n/translations";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useEffect, useState } from "react";
import Cookies from "js-cookie";
import { logger } from "@/lib/logger";

const LANGUAGE_NAMES: Record<string, string> = {
  en: "English",
  sl: "Slovenščina",
  zh: "中文",
  es: "Español",
  ar: "العربية",
  fr: "Français",
  de: "Deutsch"
};

export function LanguageSelector() {
  const { language, setLanguage } = useLanguage();
  const [selectedLanguage, setSelectedLanguage] = useState(language);
  
  useEffect(() => {
    // Keep local state in sync with context
    setSelectedLanguage(language);
    logger.log("LanguageSelector current language:", language);
    logger.log("Current cookie value:", Cookies.get("preferredLanguage"));
  }, [language]);

  const handleLanguageChange = async (newLang: string) => {
    logger.log("Language selector changing to:", newLang);
    setSelectedLanguage(newLang as any);
    
    // Set the language first
    await setLanguage(newLang as any);
    
    // Verify cookie was set
    logger.log("Cookie after language change:", Cookies.get("preferredLanguage"));
    
    // Force a page reload to ensure all components reflect the new language
    logger.log("Reloading page to apply language change");
    window.location.reload();
  };

  return (
    <Select value={selectedLanguage} onValueChange={handleLanguageChange}>
      <SelectTrigger className="w-full sm:w-[200px] flex items-center justify-between">
        <SelectValue placeholder="Select language" />
      </SelectTrigger>
      <SelectContent>
        {SUPPORTED_LANGUAGES.map((lang) => (
          <SelectItem key={lang} value={lang}>
            {LANGUAGE_NAMES[lang]}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
